import Vue from 'vue'
import Router from 'vue-router'

//PC
import Index from '@/pages/index/index'
import Diagnostics from '@/pages/index/diagnostics'
import SupplyChain from '@/pages/index/supply-chain'
import About from '@/pages/about/index'
import Partnering from '@/pages/partnering/index'
import ContractManufacturing from '@/pages/contract-manufacturing/index'
import Resources from '@/pages/resources/index'
import ResourcesInfo from '@/pages/resources/info'
import Events from '@/pages/events/index'
import EventsInfo from '@/pages/events/info'
import MediaRoom from '@/pages/media-room/index'
import Contact from '@/pages/contact/index'
import Search from '@/pages/search/index'
import Careers from '@/pages/careers/index'
import Products from '@/pages/products/index'
//import ProductsInfo from '@/pages/products/info'
import ProductsInfos from '@/pages/products/infos'
import CareersApply from '@/pages/careers/apply'
import ResourcesInfoPreview from '@/pages/resources/info-preview'
import ProductsInfoPreview from '@/pages/products/info-preview'
import PrivacyPolicy from '@/pages/policy/index'
import WebsiteTermsAndConditions from '@/pages/policy/index2'
import ANTIBRIBERYANDANTICORRUPTIONPOLICY from '@/pages/partnering/BRIBERY&POLICY'
// import FreeSample from '@/pages/free-sample/index'
// import UsageFeedback from '@/pages/usage-feedback/index'
import becomeADistributor from '@/pages/become-a-distributor/index'
import freeSampleKit from '@/pages/free-sample-kit/index'
import cordxPocNewsletter from '@/pages/cordx-poc-newsletter/index'
import scientificStrategyBoard from '@/pages/SSB/index'
import scientificStrategyBoardInfo from '@/pages/SSB/info'

Vue.use(Router);

export default new Router({
	mode: 'history',
	scrollBehavior(to, from, savePosition) {
		if(savePosition){
			return savePosition
		}else{
			return { x: 0, y: 0 }
		}
	},
	routes: [
		{
		  path: '*',
		  redirect: '/'
		},{
			path: '/',
			name: 'Index',  //主页
			component: Index,
			meta: {
				requireAuth: true
			}
		},{
			path: '/diagnostics',
			name: 'Diagnostics',  //主页子页1
			component: Diagnostics,
			meta: {
				requireAuth: true
			}
		},{
			path: '/supply-chain',
			name: 'SupplyChain',  //主页子页2
			component: SupplyChain,
			meta: {
				requireAuth: true
			}
		},{
			path: '/about',
			name: 'About',  //关于我们
			component: About,
			meta: {
				requireAuth: true
			}
		},{
			path: '/partnering',
			name: 'Partnering',  //合作伙伴
			component: Partnering,
			meta: {
				requireAuth: true
			}
		},{
			path: '/contract-manufacturing',
			name: 'ContractManufacturing',  //ContractManufacturing
			component: ContractManufacturing,
			meta: {
				requireAuth: true
			}
		},{
			path: '/media-room',
			name: 'MediaRoom',  //MediaRoom
			component: MediaRoom,
			meta: {
				requireAuth: true
			}
		},{
			path: '/contact',
			name: 'Contact',  //Contact
			component: Contact,
			meta: {
				requireAuth: true
			}
		},{
			path: '/search',
			name: 'Search',  //Search
			component: Search,
			meta: {
				requireAuth: true
			}
		},{
			path: '/careers',
			name: 'Careers',  //Careers
			component: Careers,
			meta: {
				requireAuth: true
			}
		},{
			path: '/careers-apply',
			name: 'CareersApply',  //CareersApply
			component: CareersApply,
			meta: {
				requireAuth: true
			}
		},{
			path: '/product/:cateId',
			name: 'Products',
			component: resolve => require(['@/pages/products/index'], resolve), 
			meta: {
				requireAuth: true,
			},
		},{
			path: '/products/:productInfoId',
			name: 'Productsinfo',
			component: resolve => require(['@/pages/products/info'], resolve), 
			meta: {
				requireAuth: true,
			},
		},{
			path: '/product/zt/:productInfoIds',
			name: 'Productsinfos',
			component: resolve => require(['@/pages/products/infos'], resolve), 
			meta: {
				requireAuth: true,
			},
		},{
			path: '/product/zt2/:productInfoIds',
			name: 'Productsinfos2',
			component: resolve => require(['@/pages/products/infos2'], resolve), 
			meta: {
				requireAuth: true,
			},
		},{
			path: '/product/zt3/:productInfoIds',
			name: 'Productsinfos3',
			component: resolve => require(['@/pages/products/infos3'], resolve), 
			meta: {
				requireAuth: true,
			},
		},{
			path: '/product/drugs-of-abuse/:productInfoIds',
			name: 'Productsinfos4',
			component: resolve => require(['@/pages/products/multi-drug-rapid-test-cup'], resolve), 
			meta: {
				requireAuth: true,
			},
		},{
			path: '/product/infectious-disease/:productInfoIds',
			name: 'Productsinfos5',
			component: resolve => require(['@/pages/products/rsv-rapid-test'], resolve), 
			meta: {
				requireAuth: true,
			},
		},{
			path: '/productspreview/:productInfoId',
			name: 'ProductsInfoPreview',
			component: resolve => require(['@/pages/products/info-preview'], resolve), 
			meta: {
				requireAuth: true,
			},
		},{
			path: '/resources',
			name: 'Resources',  //新闻
			component: Resources,
			meta: {
				requireAuth: true
			}
		},{
			path: '/resources/:resourcesInfoId',
			name: 'Resourcesinfo',
			component: resolve => require(['@/pages/resources/info'], resolve), 
			meta: {
				requireAuth: true,
			},
		},{
			path: '/resourcespreview/:resourcesInfoId',
			name: 'ResourcesInfoPreview',
			component: resolve => require(['@/pages/resources/info-preview'], resolve), 
			meta: {
				requireAuth: true,
			},
		},{
			path: '/events',
			name: 'Events',  //Events
			component: Events,
			meta: {
				requireAuth: true
			}
		},{
			path: '/events-info/:eventsInfoId',
			name: 'Eventsinfo',
			component: resolve => require(['@/pages/events/info'], resolve), 
			meta: {
				requireAuth: true,
			},
		},{
			path: '/Culture/Aiiso_Truth_Code',  ///culture/Policy
			name: 'Truth',  //企业文化
			component: resolve => require(['@/pages/careers/Truth'], resolve),
			meta: {
				requireAuth: true
			}
		},{
			path: '/Culture/Aiiso_Work_Code',  ///Policy/Work-Guide
			name: 'Manage',  //管理守则
			component: resolve => require(['@/pages/careers/manage'], resolve),
			meta: {
				requireAuth: true
			}
		},{
			path: '/Culture/Aiiso_Social_Art',  //Aiiso_Social_Art
			name: 'Social',  //带人技巧
			component: resolve => require(['@/pages/careers/social'], resolve),
			meta: {
				requireAuth: true
			}
		},{
			path: '/culture/cn',
			name: 'cultureCn',  //中文文化规章
			component: resolve => require(['@/pages/careers/TruthCN'], resolve),
			meta: {
				requireAuth: true
			}
		},{
			path: '/privacy-policy',
			name: 'PrivacyPolicy',  //隐私协议1
			component: resolve => require(['@/pages/policy/index'], resolve),
			meta: {
				requireAuth: true
			}
		},{
			path: '/terms-and-conditions',
			name: 'WebsiteTermsAndConditions',  //隐私协议2
			component: resolve => require(['@/pages/policy/index2'], resolve),
			meta: {
				requireAuth: true
			}
		},{
			path: '/ANTI-BRIBERY-AND-ANTI-CORRUPTION-POLICY',
			name: 'ANTIBRIBERYANDANTICORRUPTIONPOLICY',  //反贿赂和贪腐
			component: resolve => require(['@/pages/partnering/BRIBERY&POLICY'], resolve),
			meta: {
				requireAuth: true
			}
		},{
			path: '/become-a-distributor',
			name: 'becomeADistributor',  //becomeADistributor
			component: becomeADistributor,
			meta: {
				requireAuth: true
			}
		},{
			path: '/free-sample-kit',
			name: 'freeSampleKit',  //freeSampleKit
			component: freeSampleKit,
			meta: {
				requireAuth: true
			},
		},{
			path: '/cordx-poc-newsletter',
			name: 'cordxPocNewsletter',  //cordxPocNewsletter
			component: cordxPocNewsletter,
			meta: {
				requireAuth: true
			},
		},{
			path: '/scientific-strategy-board',
			name: 'scientificStrategyBoard',  //scientificStrategyBoard
			component: scientificStrategyBoard,
			meta: {
				requireAuth: true
			},
		},{
			path: '/scientific-strategy-board-info',
			name: 'scientificStrategyBoardInfo',  //scientificStrategyBoardInfo
			component: scientificStrategyBoardInfo,
			meta: {
				requireAuth: true
			},
		}
		// ,{
		// 	path: '/cordx-tyfast-mutiplex-rapid-test-poc',
		// 	name: 'CordxTyfastMutiplexRapidTestPoc',  //POC产品领取
		// 	component: resolve => require(['@/pages/free-sample/indexPoc'], resolve),
		// 	meta: {
		// 		requireAuth: true
		// 	}
		// }
		// ,{
		// 	path: '/free-sample',
		// 	name: 'FreeSample',  //free-sample
		// 	component: resolve => require(['@/pages/free-sample/index'], resolve),
		// 	meta: {
		// 		requireAuth: true
		// 	}
		// },{
		// 	path: '/usage-feedback',
		// 	name: 'UsageFeedback',  //usage-feedback
		// 	component: resolve => require(['@/pages/usage-feedback/index'], resolve),
		// 	meta: {
		// 		requireAuth: true
		// 	}
		// }
	]
})